export default __webpack_public_path__ + "02a377075b145a759c9ad3ad6020b36d.svg";